import { Pipe, PipeTransform } from '@angular/core';
import { Duration } from 'luxon';
import { RouteStop } from '../_models/view/routeStop';
import { getHoursFromString, roundMinutes } from './stop-duration-helper';

/**
 * Pipe accepts a RouteStop object
 * If the stop has a stopTime then the stopTime is subtracted from the hours.
 */
@Pipe({ name: 'stopHoursMinusDuration' })
export class StopHoursPipe implements PipeTransform {
  transform(stop: RouteStop) {
    // skip Origin (it should alway be '0:00')
    if (stop.stopTime && stop.hours && stop.stopType !== 'O') {
      const stopTime = roundMinutes(
        Duration.fromObject({
          hours: getHoursFromString(stop.stopTime),
        })
      );

      const [h, m] = stop.hours.split(':');
      // skip the minus if hours isn't 'hh:mm'
      if (h && m) {
        const stopHours = Duration.fromObject({
          hours: Number(h),
          minutes: Number(m),
        });

        return stopHours.minus(stopTime).toFormat('h:mm');
      }
    }

    return stop.hours;
  }
}
